module.exports = [
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-izljev",
		"textblock_1st_text": "31455000",
		"textblock_2nd_text": "Početni paket GROHE Blue Home Duo: jednoručna kuhinjska miješalica za filtriranu, ohlađenu i gaziranu vodu. Sadržava jedinicu za hlađenje, filtar i bocu s CO2 za karbonizaciju. Visoki izljev u obliku slova C, kromirani premaz.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-izljev",
		"textblock_1st_text": "31456000",
		"textblock_2nd_text": "Početni paket GROHE Blue Home Duo: jednoručna kuhinjska miješalica za filtriranu, ohlađenu i gaziranu vodu. Sadržava jedinicu za hlađenje, filtar i bocu s CO2 za karbonizaciju. Visoki izljev u obliku slova U, kromirani premaz.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono oprema",
		"textblock_1st_text": "31498000",
		"textblock_2nd_text": "Početni paket GROHE Blue Home Mono: stupna miješalica za filtriranu, ohlađenu i gaziranu vodu. Sadržava jedinicu za hlađenje, filtar i bocu s CO2 za karbonizaciju. Visoki izljev u obliku slova C, kromirani premaz.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-izljev ",
		"textblock_1st_text": "31454DC0",
		"textblock_2nd_text": "Početni paket GROHE Blue Home Duo: jednoručna kuhinjska miješalica za filtriranu, ohlađenu i gaziranu vodu. Sadržava jedinicu za hlađenje, filtar i bocu s CO2 za karbonizaciju. Visoki izljev u obliku slova L, izgled nehrđajućeg čelika.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-izljev",
		"textblock_1st_text": "31455DC0",
		"textblock_2nd_text": "Početni paket GROHE Blue Home Duo: jednoručna kuhinjska miješalica za filtriranu, ohlađenu i gaziranu vodu. Sadržava jedinicu za hlađenje, filtar i bocu s CO2 za karbonizaciju. Visoki izljev u obliku slova C, izgled nehrđajućeg čelika.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-izljev ",
		"textblock_1st_text": "31454000",
		"textblock_2nd_text": "Početni paket GROHE Blue Home Duo: jednoručna kuhinjska miješalica za filtriranu, ohlađenu i gaziranu vodu. Sadržava jedinicu za hlađenje, filtar i bocu s CO2 za karbonizaciju. Visoki izljev u obliku slova L, kromirani premaz.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-izljev",
		"textblock_1st_text": "31456DC0",
		"textblock_2nd_text": "Početni paket GROHE Blue Home Duo: jednoručna kuhinjska miješalica za filtriranu, ohlađenu i gaziranu vodu. Sadržava jedinicu za hlađenje, filtar i bocu s CO2 za karbonizaciju. Visoki izljev u obliku slova U, izgled nehrđajućeg čelika.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono oprema",
		"textblock_1st_text": "31498DC0",
		"textblock_2nd_text": "Početni paket GROHE Blue Home Mono: stupna miješalica za filtriranu, ohlađenu i gaziranu vodu. Sadržava jedinicu za hlađenje, filtar i bocu s CO2 za karbonizaciju. Visoki izljev u obliku slova C, izgled nehrđajućeg čelika.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325001/640/30325001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Miješalica s bojlerom L veličine",
		"textblock_1st_text": "30325001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/30325001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30085001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085001/640/30085001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Slavina s bojlerom M veličine",
		"textblock_1st_text": "30085001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/30085001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083DC1/640/30083DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Miješalica s bojlerom M veličine",
		"textblock_1st_text": "30083DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/30083DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083001/640/30083001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Miješalica s bojlerom M veličine",
		"textblock_1st_text": "30083001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/30083001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30080001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30080001/640/30080001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Slavina s bojlerom L veličine",
		"textblock_1st_text": "30080001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/30080001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079DC1/640/30079DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Miješalica s bojlerom L veličine",
		"textblock_1st_text": "30079DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/30079DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079001/640/30079001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Miješalica s bojlerom L veličine",
		"textblock_1st_text": "30079001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/30079001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "40841001",
		"image": "//cdn.cloud.grohe.com/prod/40/40/40841001/640/40841001.jpg",
		"headline": "GROHE Red",
		"subheadline": "Ventil za miješanje",
		"textblock_1st_text": "40841001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/40841001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30339001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30339001/640/30339001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Slavina s bojlerom M veličine",
		"textblock_1st_text": "30339001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/30339001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327DC1/640/30327DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Miješalica s bojlerom M veličine",
		"textblock_1st_text": "30327DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/30327DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327001/640/30327001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Miješalica s bojlerom M veličine",
		"textblock_1st_text": "30327001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/30327001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325DC1/640/30325DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Miješalica s bojlerom L veličine",
		"textblock_1st_text": "30325DC1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.hr/hr_hr/product/30325DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.hr/hr_hr/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/water_products_hr_hr.json
// module id = 882
// module chunks = 0